module.exports = __webpack_public_path__ + "static/media/Society of Dermatology Physician Assistants Logo.59f8fa89.jpeg";